import { createSlice } from '@reduxjs/toolkit';

/**
 * Мова інтерфейсу.
 *
 * Раніше вона жила лише в localStorage і читалася просто в компонентах, тому
 * перемикач мусив перезавантажувати сторінку — інакше половина екрана лишалася
 * старою мовою. Тепер мова у сховищі: перемикання перемальовує інтерфейс і
 * перезапитує розділи CMS іншою локаллю (див. useContent).
 *
 * У localStorage вона теж лишається, але вже як спосіб пережити оновлення
 * сторінки, а не як джерело правди під час роботи.
 */

const STORAGE_KEY = 'language';

/** Код локалі в CMS. На сайті мова зветься `ua`, у Strapi та ж мова — `uk`. */
export const API_LOCALE = { ua: 'uk', en: 'en' };

function stored() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'ua';
  } catch {
    // Приватний режим браузера може заборонити доступ до сховища. Мова сайту
    // не та річ, заради якої варто ламати сторінку.
    return 'ua';
  }
}

const slice = createSlice({
  name: 'language',
  initialState: stored(),
  reducers: {
    languageSet: (state, { payload }) => (payload === 'en' ? 'en' : 'ua'),
  },
});

const { languageSet } = slice.actions;

/** Перемикає мову й запам'ятовує вибір. */
export const changeLanguage = (next) => (dispatch) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // Вибір не переживе оновлення сторінки — це прикро, але не привід
    // не перемикати мову зараз.
  }

  dispatch(languageSet(next));
};

export const languageReducer = slice.reducer;
